import { Users, ClipboardList, CreditCard, CalendarDays } from 'lucide-react';

export const moduleConfig = {
  students: {
    label: 'Students',
    singular: 'student',
    icon: Users,
    gradient: 'from-indigo-600 via-purple-600 to-violet-700',
    soft: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-200',
    description: 'Find student profiles by class, batch, dropped status, or enquiry.',
  },
  exams: {
    label: 'Exam',
    singular: 'exam',
    icon: ClipboardList,
    gradient: 'from-rose-600 via-red-600 to-orange-700',
    soft: 'bg-rose-50 text-rose-700 dark:bg-rose-500/15 dark:text-rose-200',
    description: 'Add exams, marks, and rank students inside their selected batch.',
  },
  payments: {
    label: 'Payments',
    singular: 'payment',
    icon: CreditCard,
    gradient: 'from-amber-500 via-orange-600 to-amber-700',
    soft: 'bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-200',
    description: 'Check total, paid, due, and fee history for every student.',
  },
  attendance: {
    label: 'Attendance',
    singular: 'attendance',
    icon: CalendarDays,
    gradient: 'from-cyan-600 via-teal-600 to-emerald-700',
    soft: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-500/15 dark:text-cyan-200',
    description: 'Mark class attendance first, then review each student calendar.',
  },
} as const;

export type ModuleKey = keyof typeof moduleConfig;

export function getModuleConfig(module: string | undefined) {
  return moduleConfig[(module || 'students') as ModuleKey] || moduleConfig.students;
}

export function getModuleStudentPath(module: ModuleKey, studentId: number | string, classId?: string, batchId?: string) {
  // Students module uses the full StudentProfile page with tabs, passes module context via query params
  if (module === 'students') {
    const query = new URLSearchParams();
    query.set('module', module);
    if (classId) query.set('classId', classId);
    if (batchId) query.set('batchId', batchId);
    return `/students/${studentId}?${query.toString()}`;
  }
  const query = new URLSearchParams();
  if (classId) query.set('classId', classId);
  if (batchId) query.set('batchId', batchId);
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return `/modules/${module}/students/${studentId}${suffix}`;
}
